import { useSelector } from "react-redux";
import { selectListItems } from "../../../../../../redux/library/selector";
import { AccordionContainer } from "../../../../../../common/components/accordion/accordion.module";
import { InputContainer } from "../../../../../../common/components/form/input/containers/input.container";

export default function OnBoardingCertificateInfoComponent ({handleFormChange, subscriptionDetails}: any) {
    const libraryData = useSelector(selectListItems)
    return (
      <>
        <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
       <InputContainer
  
  label="CIN Number"
  name="CIN Number"
  onValueChange={(event: any) => {
    handleFormChange({
      value: event.target.value,
      field: 'CINDetails.CIN_Id',
      data: subscriptionDetails?.CINDetails
    });
  }}
  type="text"
  value={subscriptionDetails?.CINDetails?.CIN_Id}
  />

<InputContainer
  
  label="CIN_Attachments"
  name="CIN_Attachments"
  onValueChange={(newValue: any) => {
    const ipaddressData: any = newValue.map((option: any) => option?.id)
    handleFormChange({
      value: ipaddressData,
      field: 'CINDetails.CIN_Attachments',
      data: subscriptionDetails?.CINDetails
    });
  }}
  type="multiselectText"
  value={subscriptionDetails?.CINDetails?.CIN_Attachments}
  />
  <InputContainer
  
  label="Udhayam Number"
  name="Udhayam Number"
  onValueChange={(event: any) => {
    handleFormChange({
      value: event.target.value,
      field: 'CINDetails.UdhyamNumber',
      data: subscriptionDetails?.CINDetails
    });
  }}
  type="text"
  value={subscriptionDetails?.CINDetails?.UdhyamNumber}
  />

<InputContainer
  
  label="Udhyam Registered Certificate"
  name="Udhyam Registered Certificate"
  onValueChange={(newValue: any) => {
    const ipaddressData: any = newValue.map((option: any) => option?.id)
    handleFormChange({
      value: ipaddressData,
      field: 'CINDetails.UdhyamRegisteredCertificate',
      data: subscriptionDetails?.CINDetails
    });
  }}
  type="multiselectText"
  value={subscriptionDetails?.CINDetails?.UdhyamRegisteredCertificate}
  />
  <InputContainer
  
  label="DUNS Number"
  name="DUNS Number"
  onValueChange={(event: any) => {
    handleFormChange({
      value: event.target.value,
      field: 'CINDetails.DUNSNumber',
      data: subscriptionDetails?.CINDetails
    });
  }}
  type="text"
  value={subscriptionDetails?.CINDetails?.DUNSNumber}
  />
   </div>
  }
  expandedPanel="Certificate of Corporation"
  headerTitle="Certificate of Corporation"
/>
</>
  )
}